/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Library_Tab_PlansInputs */

const en_library_tab_plans = /** @type {(inputs: Library_Tab_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans`)
};

const pl_library_tab_plans = /** @type {(inputs: Library_Tab_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany`)
};

/**
* | output |
* | --- |
* | "Plans" |
*
* @param {Library_Tab_PlansInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const library_tab_plans = /** @type {((inputs?: Library_Tab_PlansInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Library_Tab_PlansInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_library_tab_plans(inputs)
	return en_library_tab_plans(inputs)
});